var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBinanceLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.89187 6.72301L7.99937 3.61678L11.1081 6.72553L12.9165 4.91715L7.99937 0L3.08348 4.91588L4.89187 6.72301ZM1.80712 6.19224L3.61425 7.99937L1.80712 9.80649L0 7.99937L1.80712 6.19224ZM4.89187 9.27699L7.99937 12.3845L11.1081 9.27573L12.9165 11.0816V11.0829L7.99937 16L3.08348 11.0854L3.08096 11.0829L4.89187 9.27699ZM16 7.99937L14.1929 9.80776L12.3845 8.00063L14.1916 6.19351L16 7.99937Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.83518 7.99899L8.00025 6.16406L6.64428 7.52004L6.48884 7.67548L6.16659 7.99646L6.16406 7.99899L6.16659 8.00278L8.00025 9.83518L9.83518 8.00025V7.99899Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBinanceLogo);
export default __webpack_public_path__ + "static/media/binanceLogo.ce4302372abbe3bfecc25816fa7833bc.svg";
export { ForwardRef as ReactComponent };